import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { BaseDataServiceV2 } from '@core/services/base-data/base-data-v2.service';
import { SubmitPrecheckinPost } from '@precheckin/models/visit/submit-precheckin-post.model';
import { VisitRecordPost } from '@precheckin/models/visit/visit-record-post.model';
import { IVisitRecord, VisitRecord } from '@precheckin/models/visit/visit-record.model';
import { VisitRequest } from '@precheckin/models/visit/visit-request.model';
import { IVisit, Visit } from '@precheckin/models/visit/visit.model';
import { ControllerRoute } from '@shared/models/enums/controller-route.enum';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitsService extends BaseDataServiceV2 {
  private readonly endpoint = ControllerRoute.Visits;

  constructor(
    appSettingsService: AppSettingsService,
    private apiService: ApiService,
    protected httpClient: HttpClient
  ) {
    super(appSettingsService);
    this.appendResource(ControllerRoute.Visits, { apiVersions: [1, 2] });
  }

  public getById(id: string): Observable<IVisit> {
    return this.apiService.get<IVisit>(`${this.endpoint}/${id}`);
  }

  public saveVisit(visit: VisitRequest): Observable<Visit> {
    return this.apiService.put<IVisit>(`${this.endpoint}/${visit.id}`, visit);
  }

  public recordPreCheckin(
    submitPrecheckinPost: SubmitPrecheckinPost
  ): Observable<VisitRecord> {
    return this.apiResourceUrlVersions$.pipe(
      switchMap((apiResourceUrlVersions) =>
        this.httpClient.post<IVisitRecord>(
          `${apiResourceUrlVersions[2]}/${submitPrecheckinPost.VisitRecord.visitId}/pre-checkin`,
          submitPrecheckinPost
        )
      ));
  }

  public recordStartPreCheckin(
    visitRecordPost: VisitRecordPost
  ): Observable<VisitRecord> {
    return this.apiService.post<IVisitRecord>(
      `${this.endpoint}/${visitRecordPost.visitId}/start-pre-checkin`,
      visitRecordPost
    );
  }

  public getVisitQrCode(visitId: string): Observable<string> {
    return this.apiService.get<string>(
      `${this.endpoint}/${visitId}/badge-qr-code`
    );
  }

  public createVisit(visit: VisitRequest): Observable<IVisit> {
    return this.apiService.post<IVisit>(this.endpoint, visit);
  }
}
